import { assign } from 'lodash'

const development = {
  api: 'https://gs-dev.qa-enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const test = {
  api: 'https://gs-dev.qa-enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const qa4 = {
  api: 'https://gs-dev.qa-enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const intg = {
  api: 'https://gs-intg.qa-enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const rel = {
  api: 'https://gs-rel.qa-enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const qa2 = {
  api: 'https://gs-stg.qa-enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const production = {
  api: 'https://gs.enphaseenergy.com',
  statusPageUrl: 'https://status.vpp.enphaseenergy.com',
  requiresStatusPageToken: true,
}

const preprod = {
  api: 'https://gs-preprod.enphaseenergy.com',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const local = {
  api: 'http://localhost:8080',
  statusPageUrl: 'https://devtestgridservices.instatus.com',
  requiresStatusPageToken: false,
}

const DEFAULT = {}

const CONFIG = {
  development,
  production,
  preprod,
  test,
  qa2,
  intg,
  rel,
  qa4,
  local,
}

const getConfig = (env) => {
  let hostname
  if (typeof window !== 'undefined') {
    hostname = window.location.hostname
    if (hostname.search('grid.enphaseenergy.com') >= 0) {
      env = 'production'
    } else if (hostname.search('grid-preprod.enphaseenergy.com') >= 0) {
      env = 'preprod'
    } else if (hostname.search('gs-console-stg.qa-enphaseenergy.com') >= 0) {
      env = 'qa2'
    } else if (hostname.search('gs-admin-ui-intg.qa-enphaseenergy.com') >= 0) {
      env = 'intg'
    } else if (hostname.search('grid-rel.qa-enphaseenergy.com') >= 0) {
      env = 'rel'
    } else if (hostname.search('gs-admin-ui-dev.qa-enphaseenergy.com') >= 0) {
      env = 'qa4'
    } else if (window.location.port === '8002') {
      env = 'qa4'
    } else {
      env = 'development'
    }
  } else if (env === 'test') {
    env = 'test'
  }

  const envConfig = CONFIG[env]
  if (envConfig) {
    return assign({}, DEFAULT, envConfig)
  }
  throw new Error('Unknown environment : ' + env)
}

export default getConfig
